import React from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import { toast } from "react-toastify";
// import { fetchDeliveryType } from "../../Services/CartService";
import { fetchConfig } from "../../Services/MainService";

export const StoreIndex = () => {
  const [configLoading, setConfigLoading] = React.useState(true);
  const dispatch = useDispatch();

  /*
  const fetchDeliveryTypes = useCallback(
    (callback) => {
      fetchDeliveryType(50, 1)
        .then((res) => {
          dispatch({ type: "setOrderTypes", payload: [...res].reverse() });
        })
        .finally(() => {
          if (callback) callback();
        });
    },
    [dispatch]
  );
  */

  React.useEffect(() => {
    fetchConfig().then(
      (res) => {
        setConfigLoading(false);
        dispatch({ type: "setConfig", payload: res });
      },
      (er) => {
        console.warn(er, "err while fetching config...");
        toast.error("Something went wrong while fetching configuration...");
      }
    );
  }, [dispatch]);
  return (
    <>
      {configLoading ? (
        <div className="config-loading">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/loader.gif"}
            style={{ height: "70px", width: "70px", objectFit: "contain" }}
            alt=""
          />
        </div>
      ) : (
        <Outlet />
      )}
    </>
  );
};
